export const LOGIN_TAG_EVENTS = {
  SUCCESS_LOGIN: 'LoginSuccess',
  FAILED_LOGIN: 'LoginFailed',
};
